export function useTournamentsLoader({ autoLoad } = { autoLoad: true }) {
  const { tournamentsEnabled } = useRuntimeConfig().public;
  const store = shallowRef<ReturnType<(typeof import('~/store/tournaments'))['useTournamentsStore']> | null>(null);

  async function load(): Promise<typeof store.value> {
    if (!tournamentsEnabled) return null;
    if (store.value) return store.value;

    const { useTournamentsStore } = await import('~/store/tournaments');

    if (typeof useTournamentsStore === 'function') {
      store.value = useTournamentsStore();
    }

    return store.value;
  }

  if (autoLoad) {
    load();
  }

  return { store, load };
}
